import { FC, useCallback } from 'react'

import { TagGroup } from '../../../../../api/core'
import { GameCardContent } from '../../../../game/components/GameCard/GameCard'
import { LiveEventsNotPublishedBadge } from '../../../../live-events/components/LiveEventsNotPublishedBadge/LiveEventsNotPublishedBadge'
import { EventDialogTab } from '../../../../live-events/hooks/useEventDialogTabs'
import { useLiveEventModal } from '../../../../live-events/hooks/useLiveEventModal'
import { TrackedGame } from '../../../../live-events/types/TrackedGame'
import { TrackingEventExample } from '../../../../live-events/types/TrackingEvents'
import ScreenshotCard from '../../ScreenshotPreviews/ScreenshotCard'

type LiveEventCardProps = {
  event: TrackingEventExample
  trackedGame: TrackedGame
  tagGroup?: TagGroup
  isNew?: boolean
}

export const LiveEventCard: FC<LiveEventCardProps> = ({ event, trackedGame, tagGroup, isNew = false }) => {
  const { showModal: showLiveEventModal } = useLiveEventModal()

  // Unified click handler for both card media and content - open live event modal
  const handleCardClick = useCallback(() => {
    showLiveEventModal({
      trackedGameId: event.gameId,
      eventTypeId: event.typeId,
      eventId: event.eventId,
      tab: EventDialogTab.Description,
      screenshotIndex: event.screenshotUrl ? 0 : undefined, // Include screenshot index if screenshot exists
    })
  }, [event.gameId, event.typeId, event.eventId, event.screenshotUrl, showLiveEventModal])

  // CardActions children: GameCardContent with LiveEventsNotPublishedBadge
  const cardActionsChildren = (
    <GameCardContent
      game={trackedGame.game}
      variant="card"
      subpage="live-events"
      showCountryFlag={false}
      hidePowerscore={false}
      displayGameType={true}
      onGameLinkClick={(e) => e.stopPropagation()}
    />
  )

  return (
    <ScreenshotCard
      title={event.name}
      inactive={!event.active}
      badgeContent={0}
      imageUrl={event.screenshotUrl}
      onImageClick={handleCardClick}
      showLatestBadge={false}
      cardActionsChildren={cardActionsChildren}
      cardActionRibbon={!trackedGame.published && <LiveEventsNotPublishedBadge sx={{ zIndex: 1 }} />}
      onCardClick={handleCardClick}
      onTitleClick={handleCardClick}
    />
  )
}
